import { useState } from 'react';
import { PromotionEnumType } from '../../../enums/promotionEnum';
import { MerChantModel } from '../../../models/merChantModel';
import { PromotionModel } from '../../../models/promotion';

interface Props {
  onClose: VoidFunction;
  onFetchData: Function;
  selectPromotionType: PromotionEnumType;
  branchValue: string;
  branchData: MerChantModel[];
  selectedData:PromotionModel
}

const useFormPromotionCOntroller = ({ selectPromotionType, branchValue,selectedData }: Props) => {
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [promotionType, setPromotionType] = useState<PromotionEnumType>(selectPromotionType);

  const handleOpenConfirmForm = (event: any) => {
    event.preventDefault();
    setOpenConfirm(true);
  };

  return {
    handleCloseConfirmForm: () => setOpenConfirm(false),
    handleOpenConfirmForm,
    openConfirm,
    promotionType,
    handleSelectPromotionType: (e: any) => setPromotionType(e.target.value),
    selectedData
  };
};
export default useFormPromotionCOntroller;
